import changePasswordTemplate from './changePassword.html';

export default angular
  .module('main.profile.tabs.changePassword', [])

  .directive('profileChangePasswordTab', () => {
    return {
      restrict: 'E',
      template: changePasswordTemplate,
      scope: {},
      controller: (
        $scope,
        $q,
        $filter,
        $interval,
        utils,
        ProfileDataProvider,
        ToastsService
      ) => {
        const $t = $filter('translate');
        $scope.dataProvider = ProfileDataProvider.instance;

        /**
         * Password change UI state (step)
         * @type {'initial'|'passcode'|'totp'}
         */
        $scope.state = 'initial';

        let countdownInterval;

        angular.extend($scope, {
          updatePassword: updatePassword,
          onSendPasscodeButtonClick: onSendPasscodeButtonClick,
          resendCode: resendCode,
          keyPressSendPasscode: keyPressSendPasscode,
          keyPressUpdatePassword: keyPressUpdatePassword,
          onCancelButtonClick: onCancelButtonClick,
          onStartOverButtonClick: onStartOverButtonClick,
          updatePasswordByTotp: updatePasswordByTotp,
          keyPressSendTotp: keyPressSendTotp,
          onSendTotpButtonClick: onSendTotpButtonClick,
        });

        init();

        function init() {
          $scope.loading = true;
          initForm();
          initWatchers();

          $q.all([
            // $scope.dataProvider.userInfoResource.init(),
            $scope.dataProvider.passwordRegexpResource.init(),
            $scope.dataProvider.passcodeTimeoutResource.init(),
          ])
            .then(() => {
              updatePwdFormRules();
              initDataModel();
              $scope.loading = false;
            }, (err) => {
              utils.handleApiError(err);
              $scope.loading = false;
            });
        }

        function initDataModel() {
          $scope.newPassword = '';
          $scope.oldPassword = '';
          $scope.newRepeatPassword = '';
          $scope.passcode = '';
          $scope.totp = '';
        }

        function initWatchers() {
          $scope.$on('$destroy', () => {
            clearCodeCountdown();
          });
        }

        function initForm() {
          $('#form-pw').form({
            inline: true,
            fields: {
              'oldPassword': {
                identifier: 'oldPassword',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.password.empty')
                  }
                ]
              },
              'newPassword': {
                identifier: 'newPassword',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.newPassword.empty')
                  }
                ]
              },
              'newRepeatPassword': {
                identifier: 'newRepeatPassword',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.newRepeatPassword.empty')
                  }, {
                    type: 'match[newPassword]',
                    prompt: $t('prompt.newRepeatPassword.notMatch')
                  }
                ]
              }
            }
          });

          $('#form-pw-2factor').form({
            inline: true,
            fields: {
              'passcode': {
                identifier: 'passcode',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('prompt.passcode.enter')
                  },
                  {
                    type: 'regExp[/^[A-Za-z0-9]{6}$/gi]',
                    prompt: $t('prompt.passcode.invalid')
                  }
                ]
              }
            }
          });

          $('#form-pw-2factor-totp').form({
            inline: true,
            fields: {
              'totp': {
                identifier: 'totp',
                rules: [
                  {
                    type: 'empty',
                    prompt: $t('profile.changePassword.totpRequired')
                  },
                  {
                    type: 'regExp[/^[0-9]{6}$/gi]',
                    prompt: $t('prompt.totp.invalid')
                  }
                ]
              }
            }
          });
        }

        function updatePwdFormRules() {
          const regExpStr = $scope.dataProvider.passwordRegexpResource.value;
          if (!regExpStr) {
            return;
          }

          try {
            const regExp = new RegExp(regExpStr);
            const regExpRule = 'regExp[' + regExp + ']';

            let pwdForm = $('#form-pw');
            pwdForm.form('add rule', 'newPassword', {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.newRepeatPassword.empty')
                },
                {
                  type: regExpRule,
                  prompt: $t('users.new.form.passwordRegex')
                }
              ]
            });
            pwdForm.form('add rule', 'newRepeatPassword', {
              rules: [
                {
                  type: 'empty',
                  prompt: $t('prompt.newRepeatPassword.empty')
                },
                {
                  type: regExpRule,
                  prompt: $t('users.new.form.passwordRegex')
                },
                {
                  type: 'match[newPassword]',
                  prompt: $t('prompt.newRepeatPassword.notMatch')
                }
              ]
            });
          } catch (ex) {
            $log.warn(`Unable to parse password regExp string: "${regExpStr}"`);
            $log.warn(ex);
          }
        }

        function updatePassword() {
          const formEl = $('#form-pw');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid || !$scope.newPassword) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.setNewPassword($scope.newPassword, $scope.oldPassword)
            .then(() => {
              onChangePasswordSuccess();
              // NOTE: In fact, we should never get here.
              //  If we change the password for the admin (no one except admins can access Maestro),
              //  then entering the passcode from SMS or TOTP is required.
            }, (err) => {
              $scope.loading = false;
              if (err && err.resultCode === 17) {
                $scope.state = 'passcode';
                $scope.pwPasscodeMessage = err.resultCodeMessage || err.resultCodeDesc;
                startCodeCountdown();
                return;
              }
              utils.handleApiError(err);
              $scope.state = 'initial';
              $scope.pwErrorMessage = err?.resultCodeMessage;
            });
        }

        function onSendPasscodeButtonClick() {
          const formEl = $('#form-pw-2factor');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid || !$scope.passcode) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.confirmPasscode($scope.newPassword, $scope.oldPassword, $scope.passcode.toUpperCase())
            .then(() => {
              onChangePasswordSuccess();
            }, (err) => {
              $scope.loading = false;
              $scope.state = 'passcode';
              if (err && err.resultCode === 17) {
                $scope.pwPasscodeMessage = err.resultCodeMessage || err.resultCodeDesc;
                startCodeCountdown();
                return;
              }
              utils.handleApiError(err);
              $scope.pwErrorMessage = err?.resultCodeMessage;
            });
        }

        function updatePasswordByTotp() {
          const formEl = $('#form-pw');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid || !$scope.newPassword) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.setNewPasswordByTotp($scope.newPassword, $scope.oldPassword)
            .then(() => {
              onChangePasswordSuccess();
              // NOTE: In fact, we should never get here.
              //  If we change the password for the admin (no one except admins can access Maestro),
              //  then entering the passcode from SMS or TOTP is required.
            }, (err) => {
              $scope.loading = false;
              if (err && err.resultCode === 17) {
                $scope.state = 'totp';
                $scope.pwPasscodeMessage = err.resultCodeMessage || err.resultCodeDesc;
                return;
              }
              utils.handleApiError(err);
              $scope.state = 'initial';
              $scope.pwErrorMessage = err?.resultCodeMessage;
            });
        }

        function onSendTotpButtonClick() {
          const formEl = $('#form-pw-2factor-totp');
          formEl.form('validate form');
          let isValid = formEl.form('is valid');
          if (!isValid || !$scope.totp) {
            return;
          }

          $scope.loading = true;
          $scope.dataProvider.confirmNewPasswordByTotp($scope.newPassword, $scope.oldPassword, $scope.totp)
            .then(() => {
              onChangePasswordSuccess();
            }, (err) => {
              $scope.loading = false;
              $scope.state = 'totp';
              if (err && err.resultCode === 17) {
                $scope.pwPasscodeMessage = err.resultCodeMessage || err.resultCodeDesc;
                startCodeCountdown();
                return;
              }
              utils.handleApiError(err);
              $scope.pwErrorMessage = err?.resultCodeMessage;
            });
        }

        function onChangePasswordSuccess() {
          $scope.loading = false;
          clearCodeCountdown();
          $scope.newPassword = '';
          $scope.oldPassword = '';
          $scope.newRepeatPassword = '';
          $scope.passcode = '';
          $scope.totp = '';

          // Show success and switch to User Info tab
          ToastsService.success(null, $t('profile.changePassword.changePasswordSuccess'));
          $scope.dataProvider.activeTab = 'dashboard';
        }

        function startCodeCountdown() {
          clearCodeCountdown();
          $scope.passcodeResendCountdown = $scope.dataProvider.passcodeTimeoutResource.value;
          countdownInterval = $interval(() => {
            if ($scope.passcodeResendCountdown <= 0 || countdownInterval == null) {
              clearCodeCountdown();
              return;
            }
            $scope.passcodeResendCountdown = $scope.passcodeResendCountdown - 1;
          }, 1000);
        }

        function clearCodeCountdown() {
          $scope.passcodeResendCountdown = -1;
          if (countdownInterval != null) {
            $interval.cancel(countdownInterval);
            countdownInterval = undefined;
          }
        }

        function resendCode() {
          return $scope.updatePassword();
        }

        function keyPressSendPasscode($event) {
          if ($event.keyCode === 13) {
            $scope.onSendPasscodeButtonClick();
          }
        }

        function keyPressSendTotp($event) {
          if ($event.keyCode === 13) {
            $scope.onSendTotpButtonClick();
          }
        }

        function keyPressUpdatePassword($event) {
          if ($event.keyCode === 13) {
            $scope.updatePassword();
          }
        }

        function onCancelButtonClick() {
          if ($scope.loading) {
            return;
          }
          clearCodeCountdown();
          $scope.state = 'initial';
        }

        function onStartOverButtonClick() {
          $scope.state = 'initial';
        }

      }
    };
  })
  .name;
